export default __webpack_public_path__ + "static/media/shapeRed.6271435f.svg";